"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DropdownColumnHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownColumnHeader, _Component);

  var _super = _createSuper(DropdownColumnHeader);

  function DropdownColumnHeader() {
    var _this;

    (0, _classCallCheck2.default)(this, DropdownColumnHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onItemFieldChange", function (field, value) {
      var _this$props = _this.props,
          item = _this$props.item,
          onChange = _this$props.onChange;

      var updatedItem = _objectSpread(_objectSpread({}, item), {}, (0, _defineProperty2.default)({}, field, value));

      onChange(updatedItem);
    });
    return _this;
  }

  (0, _createClass2.default)(DropdownColumnHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _item$url,
          _item$external;

      var item = this.props.item;
      var itemName = 'name' in item ? item.name : item.title;
      var hasChildren = item.children && item.children.length > 0;
      var hasUrl = ('url' in item);
      return (0, _preact.h)("div", {
        className: "dropdown-column__form"
      }, (0, _preact.h)("div", {
        className: "dropdown-section"
      }, (0, _preact.h)("div", {
        className: "dropdown-section__header"
      }, (0, _preact.h)("h4", {
        className: "dropdown-section__title"
      }, 'name' in item ? 'Dropdown Settings' : item.title || 'Untitled')), (0, _preact.h)("div", {
        className: "dropdown-section__body"
      }, (0, _preact.h)("div", {
        className: "dropdown-item-form__fields"
      }, (0, _preact.h)(_InputGroup.default, {
        value: itemName || '',
        onChange: function onChange(e) {
          var fieldName = 'name' in item ? 'name' : 'title';

          _this2.onItemFieldChange(fieldName, e.target.value);
        },
        placeholder: "Title",
        newStyle: true
      }), hasUrl && (0, _preact.h)(_InputGroup.default, {
        value: (_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '',
        onChange: function onChange(e) {
          return _this2.onItemFieldChange('url', e.target.value);
        },
        placeholder: "URL",
        type: "url",
        newStyle: true,
        disabled: hasChildren
      }), hasUrl && (0, _preact.h)(_Checkbox.default, {
        label: "Open in new tab",
        onUpdate: function onUpdate() {
          return _this2.onItemFieldChange('external', !item.external);
        },
        checked: (_item$external = item.external) !== null && _item$external !== void 0 ? _item$external : false
      })))));
    }
  }]);
  return DropdownColumnHeader;
}(_preact.Component);

exports.default = DropdownColumnHeader;